/*
  La Famille Tremblay - kleur en maat wijzigen in de winkelmand (rustige versie)
  Eén keuzemenu per product, bijvoorbeeld "Marine / M".
  Bij wijzigen: nieuwe variant met hetzelfde aantal erin, daarna oude regel eruit.
*/
(function () {
  if (typeof CartDrawerController === 'undefined') return;
  var P = CartDrawerController.prototype;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var GIFT_ID = 15712408142089;
  var cache = {};

  var css = document.createElement('style');
  css.textContent = [
    '.lftv{margin:8px 0 6px}',
    '.lftv select{height:40px;max-width:100%;border:1px solid #d6d6d6;border-radius:6px;padding:0 34px 0 12px;font:inherit;font-size:14px;color:#555;cursor:pointer;-webkit-appearance:none;appearance:none;background:#fff url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 fill=%27none%27 stroke=%27%23555%27 stroke-width=%271.6%27/%3E%3C/svg%3E") no-repeat right 12px center/12px 8px}',
    '.lftv select:disabled{opacity:.6;cursor:wait}',
    '.lftv-err{margin:6px 0 0;font-size:13px;color:#b3261e}',
    '.lftv-on .cart-drawer__item-variant{display:none}'
  ].join('');
  document.head.appendChild(css);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  P.lftvRender = async function (cart) {
    var D = this.drawer;
    var items = (cart.items || []).filter(function (i) { return Number(i.product_id) !== GIFT_ID && i.handle; });
    for (var n = 0; n < items.length; n++) {
      var item = items[n];
      var sel = '[data-cart-item-key="' + CSS.escape(item.key) + '"]';
      var li = D.querySelector(sel);
      if (!li || li.querySelector('.lftv')) continue;
      var product = await getProduct(item.handle);
      if (!product || !product.variants || product.variants.length < 2) continue;
      li = D.querySelector(sel);
      if (!li || li.querySelector('.lftv')) continue;
      var opts = product.variants.map(function (v) {
        var cur = Number(v.id) === Number(item.variant_id);
        var off = !v.available && !cur;
        return '<option value="' + v.id + '"' + (cur ? ' selected' : '') + (off ? ' disabled' : '') + '>' + esc(v.title) + (off ? ' (épuisé)' : '') + '</option>';
      }).join('');
      var box = document.createElement('div');
      box.className = 'lftv';
      box.innerHTML = '<select aria-label="Couleur et taille" data-lftv-key="' + esc(item.key) + '" data-lftv-qty="' + item.quantity + '">' + opts + '</select><p class="lftv-err" hidden></p>';
      var anchor = li.querySelector('.cart-drawer__item-top > div') || li.querySelector('.cart-drawer__item-content');
      if (anchor) { anchor.appendChild(box); li.classList.add('lftv-on'); }
    }
  };

  P.lftvChange = async function (select) {
    var box = select.closest('.lftv');
    var err = box && box.querySelector('.lftv-err');
    if (err) err.hidden = true;
    var id = Number(select.value);
    if (!id) return;
    select.disabled = true;
    var h = { 'Content-Type': 'application/json', Accept: 'application/json' };
    try {
      var add = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: h, body: JSON.stringify({ items: [{ id: id, quantity: Number(select.dataset.lftvQty) || 1 }] }) });
      if (!add.ok) throw new Error('add failed');
      await fetch(ROOT + 'cart/change.js', { method: 'POST', headers: h, body: JSON.stringify({ id: select.dataset.lftvKey, quantity: 0 }) });
    } catch (e) {
      if (err) { err.textContent = 'Cette option n’est pas disponible. Choisissez une autre couleur ou taille.'; err.hidden = false; }
      select.disabled = false;
      return;
    }
    await this.refresh();
  };

  var prevChange = P.handleDrawerChange;
  P.handleDrawerChange = async function (event) {
    var s = event.target.closest && event.target.closest('select[data-lftv-key]');
    if (s) { await this.lftvChange(s); return; }
    return prevChange.call(this, event);
  };

  var prevExtras = P.lftExtras;
  P.lftExtras = function (cart) {
    prevExtras.call(this, cart);
    this.lftvRender(cart).catch(function (e) { console.error(e); });
  };
})();
